import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const AccessGrantsPage = lazy(() => import("@/features/dashboard/pages/access-grants"));

export const Route = createFileRoute("/(app)/dashboard/access-grants")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground p-6 text-sm">Loading access grants...</div>}>
      <AccessGrantsPage />
    </Suspense>
  ),
});
